module.exports = __webpack_public_path__ + "img/team-icon.2c82902e.svg";